import { useEffect, useState } from "react";
import { getPromoCountdown, isPromoActive } from "@/config/promo";

/**
 * Compact live countdown to `PROMO_END_ISO`. Renders `Xd Xh Xm Xs`
 * and disappears cleanly once the promo has ended (returns `null`).
 *
 * Ticking cadence: 1s. Cheap enough (single setInterval per mount) and
 * mandatory for the seconds column to make sense.
 */
export default function PromoCountdown({ className = "", "data-testid": testId }) {
  const [tick, setTick] = useState(() => getPromoCountdown());

  useEffect(() => {
    if (!isPromoActive()) return undefined;
    const id = setInterval(() => setTick(getPromoCountdown()), 1000);
    return () => clearInterval(id);
  }, []);

  if (tick.expired) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 tabular-nums ${className}`}
      aria-label={`Promoción termina en ${tick.d} días, ${tick.h} horas, ${tick.m} minutos, ${tick.s} segundos`}
      data-testid={testId || "promo-countdown"}
    >
      <span>{tick.d}d</span>
      <span>{String(tick.h).padStart(2, "0")}h</span>
      <span>{String(tick.m).padStart(2, "0")}m</span>
      <span>{String(tick.s).padStart(2, "0")}s</span>
    </span>
  );
}
